import { Modal, Switch } from "antd";
import { useEffect, useState } from "react";
import Schedule from "ui/automation/schedule";
import { showToast } from "ui/components/common";
import { getMonitorScheduleByCamera, saveMonitoringSchedule } from "./service";
import { useParams } from "react-router-dom";

export default function MonitoringModal({ visible, onClose, onRefresh, data }) {
  const { orgid } = useParams();
  const [enableMonitoring, setEnableMonitoring] = useState(false);
  const [schedule, setSchedule] = useState([]);
  const [backEndTimeZone, setBackEndTimeZone] = useState("");
  const [valid, setValid] = useState(false);
  useEffect(() => {
    if (data?.id && visible) {
      getMonitorScheduleByCamera(data.id, orgid).then((res) => {
        if (res.status === 200) {
          setEnableMonitoring(
            res.data?.camConfig?.monitorSchedule?.enableMonitoring,
          );
          setSchedule(res.data?.camConfig?.monitorSchedule?.schedules);
          setBackEndTimeZone(res.data?.camConfig?.monitorSchedule?.timezone);
        } else {
          showToast(1, "Failed to get monitoring schedule");
        }
      });
    }
    if (!visible) {
      setEnableMonitoring(false);
      setSchedule([]);
      setBackEndTimeZone("");
    }
  }, [visible]);
  useEffect(() => {
    if (schedule.length) {
      setValid(true);
    } else {
      setValid(false);
    }
  }, [schedule]);
  async function onSave() {
    const res = await saveMonitoringSchedule(
      [data.id],
      {
        schedules: schedule,
        timezone: data.site?.timezone,
        enableMonitoring: enableMonitoring,
      },
      data.site.id,
      orgid,
    );
    if (res.status === 200) {
      showToast(0, "Monitoring schedule saved successfully");
      onClose();
      onRefresh();
    } else {
      showToast(1, "Failed to save monitoring schedule");
    }
  }
  return (
    <Modal
      open={visible}
      onCancel={onClose}
      title="Manage Camera Monitoring"
      okButtonProps={{
        className: "primaryButton",
        onClick: onSave,
        disabled: !valid,
      }}
      cancelButtonProps={{ className: "primaryButton bordered" }}
      okText="Confirm"
    >
      <div style={{ marginTop: "18px" }}>
        <span style={{ fontSize: "16px", fontWeight: "600" }}>
          Site Timezone:{data?.site?.timezone}
        </span>
      </div>
      {backEndTimeZone && backEndTimeZone !== data?.site?.timezone && (
        <div style={{ marginTop: "18px" }}>
          <span style={{ fontSize: "16px", fontWeight: "600" }}>
            Last Saved Timezone:{backEndTimeZone}, please noted that the next
            saving will be based on Site Timezone.
          </span>
        </div>
      )}
      <div style={{ marginTop: "12px" }}>
        <span style={{ fontSize: "16px", fontWeight: "600" }}>
          Enable Monitoring
        </span>
        <Switch
          checked={enableMonitoring}
          onChange={setEnableMonitoring}
          style={{ marginLeft: "12px" }}
        />
      </div>
      <Schedule alertSchedules={schedule} setAlertSchedules={setSchedule} />
    </Modal>
  );
}
